import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white" style={{ color: 'var(--gray-900)' }}>
      <div className="container" style={{ padding: '60px 20px 40px 20px' }}>
        <div className="grid grid-cols-3" style={{ marginBottom: '48px' }}>
          <div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '16px', color: 'var(--gray-900)' }}>Natalie Vinueza</h3>
            <p style={{ color: 'var(--gray-600)', lineHeight: '1.6', marginBottom: '24px' }}>
              Persona coach specializing in helping professionals balance their authentic self with corporate expectations while overcoming imposter syndrome.
            </p>
          </div>
          
          <div>
            <h4 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '20px', color: 'var(--gray-900)' }}>Offerings</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '12px' }}>
                <a href="#services" style={{ color: 'var(--gray-600)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }}>
                  Being Authentically You
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#services" style={{ color: 'var(--gray-600)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }}>
                  Work-Life Harmony
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#services" style={{ color: 'var(--gray-600)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }}>
                  Influence & Impact
                </a>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <a href="#services" style={{ color: 'var(--gray-600)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }}>
                  Artist's Way Workshops
                </a>
              </li>
              <li>
                <a href="#contact" style={{ color: 'var(--gray-600)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s ease' }}>
                  Private Consultations
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '20px', color: 'var(--gray-900)' }}>Contact</h4>
            <div style={{ marginBottom: '24px' }}>
              <div style={{ marginBottom: '12px' }}>
                <p style={{ color: 'var(--gray-500)', fontSize: '12px', margin: '0 0 4px 0' }}>Email</p>
                <a href="mailto:info@personacoach.net" style={{ color: 'var(--gray-600)', textDecoration: 'none', fontSize: '14px' }}>
                  info@personacoach.net
                </a>
              </div>
            </div>
            
            <a href="#contact" className="btn btn-primary" style={{ fontSize: '14px', padding: '10px 20px' }}>
              Schedule Consultation
            </a>
          </div>
        </div>
        
        <div style={{
          borderTop: '1px solid var(--gray-200)',
          paddingTop: '32px',
          textAlign: 'center'
        }}>
          <p style={{ color: 'var(--gray-500)', fontSize: '14px', margin: 0 }}>
            &copy; 2024 Natalie Vinueza. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;